import { useState } from 'react';
import { Modal } from './ui';
import { api } from '../api';

export default function PasswordModal({ onClose }) {
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.next !== form.confirm) return setError('Les deux mots de passe ne correspondent pas');
    try {
      await api.changePassword(form.current, form.next);
      setDone(true);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Modal title="Changer mon mot de passe" onClose={onClose}>
      {done ? (
        <div className="form-stack">
          <div className="alert alert-success">Mot de passe mis à jour.</div>
          <button className="btn btn-primary" onClick={onClose}>Fermer</button>
        </div>
      ) : (
        <form onSubmit={submit} className="form-stack">
          {error && <div className="alert alert-error">⚠️ {error}</div>}
          <div className="form-group">
            <label className="form-label">Mot de passe actuel</label>
            <input type="password" className="form-input" autoComplete="current-password" value={form.current} onChange={set('current')} required />
          </div>
          <div className="form-group">
            <label className="form-label">Nouveau mot de passe (6 caractères min.)</label>
            <input type="password" className="form-input" autoComplete="new-password" minLength={6} value={form.next} onChange={set('next')} required />
          </div>
          <div className="form-group">
            <label className="form-label">Confirmer</label>
            <input type="password" className="form-input" autoComplete="new-password" value={form.confirm} onChange={set('confirm')} required />
          </div>
          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Annuler</button>
            <button className="btn btn-primary">Enregistrer</button>
          </div>
        </form>
      )}
    </Modal>
  );
}
